import { Typography } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../../../../Icon"

import styles from "./styles.module.less"

const { Title, Text } = Typography

const EmptyCases = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.wrap}>
      <span className={styles.icon}>
        <Icon type="receipt_bill" style={{ fontSize: 50 }} />
      </span>
      <Title level={3} className={styles.title} data-testid="deflect-ce-empty-cases-title">
        {t("No fraud disputes yet")}
      </Title>
      <Text
        type="secondary"
        className={styles.text}
        data-testid="deflect-ce-empty-cases-description"
      >
        {t("Fraud disputes checked against your past orders will appear here.")}
      </Text>
    </div>
  )
}

export default EmptyCases
